import React from 'react';
import { resolvePublicAssets } from '../../../../../utils';
import { getLanguage } from '../../../../../selectors/userSelectors';
import { ButtonBgColorMapping } from './buttonBgColorMapping';
import { EmmaPartnerService } from '../../../types/EmmaPartnerService';
import env from '../../../../../env';
import './styles.scss';
import _ from 'lodash';
import withButtonIconABTestHoc from './ab-test/withButtonIconABTestHoc';
import ButtonIcon from './ab-test/components/ButtonIcon';

export const ServiceButton = (props: EmmaPartnerService) => {
  const { label, icon, deepLink, id, enableNewFeatureDot } = props;
  const uniqueKey: string =
    _.get(deepLink, 'query.disclaimer', undefined) || id || '';
  const imgSrc: string = resolvePublicAssets(`assets/${icon}`).replace(
    '.png',
    '@3x.png',
  );
  const bgColor: string = ButtonBgColorMapping[uniqueKey];
  const WrappedButtonIcon = env.ENABLE_GOOGLE_OPTIMIZE_AB_TEST
    ? withButtonIconABTestHoc(ButtonIcon)
    : ButtonIcon;

  // const [hovered, setHovered] = useState(false);
  // const toggleHovered = () => {
  //     if (isMobile()) {
  //         return;
  //     }
  //     setHovered(!hovered);
  // }
  // const [clicked, setClicked] = useState(false);
  // const toggleClicked = () => {
  //     if (!isMobile()) {
  //         return;
  //     }
  //     setClicked(!clicked);
  // }
  return (
    <div
      className="card"
      // onMouseEnter={toggleHovered} onMouseLeave={toggleHovered} onClick={toggleClicked}
    >
      <div
        className="partner-service-button"
        // style={{ transform: `${hovered || clicked ? 'rotateY(180deg) ' : ''}`, transition: 'transform 0.1s' }}
      >
        {/* <div className="partner-service-button--back" style={{ backgroundColor: bgColor }}>
                    <Link key={uniqueKey} to={`${deepLink.host}/${uniqueKey}`}><div className="back-btn"></div></Link>
                </div> */}
        {enableNewFeatureDot && <div className="card__new-feature-dot"></div>}
        <div
          className="partner-service-button--front"
          // style={{ pointerEvents: hovered || clicked ? 'none' : 'auto', backgroundColor: bgColor }}>
          style={{ backgroundColor: bgColor }}
        >
          <div className="partner-service-button__icon">
            <WrappedButtonIcon imgSrc={imgSrc} uniqueKey={uniqueKey} />
            <div className="partner-service-button__label">
              {label?.[getLanguage()]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
